define('v3/Common/Services/navigationService',['env', 'jquery'], function (env, $) {
	var prefix = '/V3/' + env.userInfo.classId + '/';

	return {
		navigateTo: function (pageName, params) {
			var options = params ? '#' + $.param(params, true) : '';
			window.location = prefix + pageName + options;
		}
	};
});
